import { SurveyTypeURL } from "../../Enums/constants";
import store from "../../components/Stores/SurveyStore";
import ibsStore from "../../components/Stores/IbsSurveyStore";
import userStore from "../../components/Stores/UserStore";
import { isPabsURL } from "../../helpers"


export function getSurveyResponseValue(name, props) {
    let responseValue = ""

    if (isPabsURL()) {
        responseValue = GetSurveyResponseValuePABS(name);
    } else if (store.surveyTypeUrl === SurveyTypeURL.DC || store.surveyTypeUrl === SurveyTypeURL.DB) {
        responseValue = getSurveyResponseIBS(name, props);
    }

    // TODO PABS: Is null sometimes a valid response 
    return responseValue ?? "";
}

function getSurveyResponseIBS(name, props) {
    //ibs
    let responseValue = "";
    if (!ibsStore.allResponses)
        return ""

    responseValue = ibsStore.allResponses[name]
    if (ibsStore.allTableResponses["PlanDesign"] && props && (props.participantType == 0 || props.participantType == 1)) { //&& props.participantType) {// && (props.participantType.toString() == 0 || props.participantType.toString() == 1)) {

        var index = ibsStore.allTableResponses["PlanDesign"].findIndex(function (element) {
            var i = element.ParticipantType ? 1 : 0;
            return i === props.participantType;
        });

        if (index < 0)
            responseValue = "";
        else
            responseValue = ibsStore.allTableResponses["PlanDesign"][index][name]

    }
    return responseValue
}

function GetSurveyResponseValuePABS(name) {
    //pabs
    let responseValue = ""

    let result;
    if (store.currentPageResponse && name) {
        result = store.currentPageResponse.filter(obj => {
            return (obj.QuestionName).toLowerCase() === name.toLowerCase()
        })
    }

    if (result && result.length === 0 && store.allPageResponses["combined"] != null) {
        result = store.allPageResponses["combined"].filter(obj => {
            return (obj.QuestionName).toLowerCase() === name.toLowerCase()
        })
    }
    if (result && result[0] != null) {
        responseValue = result[0].InputValue
    }

    return responseValue
}

export function setSurveyResponseValue(name, value, props) {

    if (isPabsURL()) {
        setPabsSurveyResponse(name, value);
    } else if (store.surveyTypeUrl === SurveyTypeURL.DB || store.surveyTypeUrl === SurveyTypeURL.DC) {
        setIbsSurveyResponse(name, value, props)
    }

}

function setIbsSurveyResponse(name, value, props) {
    //bundle special cases elsewhere
    if (props != null && ibsStore.allTableResponses && ibsStore.allTableResponses["PlanDesign"] && props.participantType != undefined && (props.participantType.toString() == "0" || props.participantType.toString() == "1")) {
        //its plandesign type
        var index = ibsStore.allTableResponses["PlanDesign"].findIndex(function (element) {
            return element.ParticipantType == props.participantType;
        });

        //   console.log("name, value ", ibsStore.allTableResponses["PlanDesign"][index][props.name], value)
        ibsStore.allTableResponses["PlanDesign"][index][props.name] = value;

    }

    else {
        ibsStore.allResponses[name] = value

    }
}
function setPabsSurveyResponse(name, value, props) {
    if (store.currentPageResponse) {

        let result = store.currentPageResponse.filter(obj => {
            return (obj.QuestionName).toLowerCase() === name.toLowerCase()
        })

        if (result[0] != null) {
            result[0].InputValue = value;
            result[0].Name = userStore.accountInfo.firstName + " " + userStore.accountInfo.lastName;

        }
        else {
            store.currentPageResponse.push({ "QuestionName": name, "InputValue": value });
        }

        let result2 = store.allPageResponses["combined"]?.filter(obj => {
            return (obj.QuestionName).toLowerCase() === name.toLowerCase()
        });
        if (result2[0] != null) {
            result2[0].InputValue = value;
            result2[0].Name = userStore.accountInfo.firstName + " " + userStore.accountInfo.lastName;

        } else {
            store.allPageResponses["combined"]?.push({ "QuestionName": name, "InputValue": value });
        }
    }
}